(function (window) {
  function init() {
    const phoneFields = document.querySelectorAll('[data-intl-tel]:not([data-component-init])');
    const defaultData = {
      initialCountry: (typeof ACC !== 'undefined') ? ACC.currentCountry.toLowerCase() : 'US',
      autoFormat : true,
      placeholderNumberType: 2,
      nationalMode : true,
      formatOnDisplay: true,
      utilsScript: intlTelInputUtils
    }

    phoneFields.forEach(field => {
      intlTelInput(field, defaultData);
      field.setAttribute('data-component-init', 'true');
    });
  }

  componentEvents.on('component-init', init);

  init();

})(this);
